export default __webpack_public_path__ + "static/media/briefcase.99e44a83.png";